import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconCameraOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, t, l, _, g, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--camera-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Camera Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-.853-.854H2A1.5 1.5 0 0 1 .5 9V4.5A1.5 1.5 0 0 1 2 3h.293L.646 1.354a.5.5 0 0 1 0-.708ZM3.293 4H2a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 .5.5h6.793L7.309 8.016a2 2 0 0 1-2.825-2.824L3.293 4Zm1.9 1.9A1 1 0 0 0 6.6 7.308L5.193 5.901ZM4.25 2a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .384.18L8.734 3H10a1.5 1.5 0 0 1 1.5 1.5v3.75a.5.5 0 0 1-1 0V4.5A.5.5 0 0 0 10 4H8.5a.5.5 0 0 1-.384-.18l-1.1-1.32H4.75a.5.5 0 0 1-.5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const b = /* @__PURE__ */ u(f, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=camera-off.js.map
